<ion-content class="ion-padding">
  <img class="logo" src="assets/img/maurelligroup-logo-white.svg" alt="Maurelli Group" />
  <ion-button class="btn-login" expand="block" (click)="loginClick()">Accedi</ion-button>
</ion-content>
